import styled from 'styled-components'
import { MouseEvent } from 'react'
import Icon from './Icon'
import { Anchor } from '../'
import { type IconProps } from './Styles'

interface ToggleIconProps extends Omit<IconProps, 'onClick' | 'name'> {
  toggled?: boolean
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void
}

export const StyledIcon = styled(Icon)`
  &&& {
    font-size: 10px !important;
  }
`

const ToggleIcon = ({ toggled, onClick, className }: ToggleIconProps) => (
  <Anchor
    className={className}
    onClick={
      onClick
        ? e => {
            e.preventDefault()
            onClick(e)
          }
        : undefined
    }>
    <StyledIcon
      button
      size="large"
      name={toggled ? 'icon-toggled' : 'icon-toggle'}
    />
  </Anchor>
)

export default ToggleIcon
